
import { h } from 'preact';
import Form from 'components/bolt/forms/form/form';

export default class CinemarkForm extends Form {
	renderHiddenFields() {
		const date = this.props.data.formDate;
		const { selectedTheaterName, movieTitle, selectedTheaterCity } = this.props;
		return (
			<div id="hidden-fields">
				<input type="hidden" name="cmEventType" value="Private Screening" />
				<input type="hidden" name="cmLeadSource" value="Partner" />
				<input type="hidden" name="cmMovieSource" value={movieTitle} />
				<input type="hidden" name="cmTheatreName" value={selectedTheaterName} />
				<input type="hidden" name="cmTheatreCity" value={selectedTheaterCity} />
				<input type="hidden" name="cmRequestedEventDate" value={new Intl.DateTimeFormat('en-US').format(new Date(date))} />
			</div>
		);
	}
}